
// 产品详情页修改底部导航栏高度
function get_div_footer_box(){
    const url = new URL(window.location.href);
    const path = url.pathname.split('/');
    const firstRoute = path[1];
    const secondRoute = path[2];
    console.log(firstRoute)

    // 获取具有 'div_footer_box' 类的所有元素
    var div_footer_box = document.querySelectorAll('.div_footer_box');
    console.log('div_footer_box')
    console.log(div_footer_box)
    let num = 0
    if(firstRoute == "products" || secondRoute == "products"){
      if(window.innerWidth > 768){
        num = 70
      }else if(window.innerWidth > 451 && window.innerWidth < 768){
        num = 70
      }else{
        num = 70
      }
      if(div_footer_box){
        // 遍历并处理这些元素
        div_footer_box.forEach(function(element) {
          element.style.paddingBottom = num + 'px'
        });
      }
    }
  }

document.addEventListener('DOMContentLoaded', function() {
    get_div_footer_box()
});